'use client'
import splitbee from '@splitbee/web';
import { useEffect } from 'react';

export function Splitbee () {
  useEffect(() => {
    splitbee.init({
      disableCookie: true,

      scriptUrl: "/bee.js",
      apiUrl: "/_hive",
    })
  }, [])

  return null
}
